const $win = $(window);
const $linkInline = $('.js-inline-scroll ul .current a');

if ($win.width() < 1025 && $linkInline.length) {
  const linkInlinePosLeft = $linkInline.position().left;

  $linkInline.closest('ul').scrollLeft(linkInlinePosLeft)
};



// WEBPACK FOOTER //
// ../assets/js/mobile-inline-nav.js